import React from 'react';
import { useCourses } from '../../context/CourseContext';
import { CheckCircle, Circle, CheckSquare, Square } from 'lucide-react';
interface CourseProgressProps {
  courseId: string;
}
const CourseProgress: React.FC<CourseProgressProps> = ({
  courseId
}) => {
  const {
    getCourseProgress,
    courses
  } = useCourses();
  const progress = getCourseProgress(courseId);
  const course = courses.find(c => c.id === courseId);
  if (!course || !progress) return null;
  const totalModules = course.modules.length;
  const completedModules = progress.completedModules.length;
  const progressPercentage = totalModules > 0 ? Math.round(completedModules / totalModules * 100) : 0;
  const steps = [{
    id: 'pre',
    label: 'Pre-Assessment',
    completed: progress.preAssessmentCompleted
  }, {
    id: 'content',
    label: 'Course Content',
    completed: completedModules === totalModules && totalModules > 0
  }, {
    id: 'post',
    label: 'Post-Assessment',
    completed: progress.postAssessmentCompleted
  }, {
    id: 'cert',
    label: 'Certificate',
    completed: progress.certificateGenerated
  }];
  return <div className="bg-white rounded-lg shadow-sm p-6 mb-6" data-id="element-114">
      <h3 className="text-lg font-medium text-gray-800 mb-4" data-id="element-115">Your Progress</h3>
      <div className="mb-4" data-id="element-116">
        <div className="flex justify-between items-center mb-2" data-id="element-117">
          <span className="text-sm font-medium text-gray-700" data-id="element-118">
            {progressPercentage}% Complete
          </span>
          <span className="text-sm text-gray-500" data-id="element-119">
            {completedModules}/{totalModules} modules
          </span>
        </div>
        <div className="w-full bg-gray-200 rounded-full h-2.5" data-id="element-120">
          <div className="bg-blue-600 h-2.5 rounded-full" style={{
          width: `${progressPercentage}%`
        }} data-id="element-121"></div>
        </div>
      </div>
      <div className="space-y-4" data-id="element-122">
        {steps.map((step, index) => <div key={step.id} className="flex items-start" data-id="element-123">
            <div className="flex-shrink-0 mt-0.5" data-id="element-124">
              {step.completed ? <CheckCircle size={18} className="text-green-500" data-id="element-125" /> : <Circle size={18} className="text-gray-300" data-id="element-126" />}
            </div>
            <div className="ml-3" data-id="element-127">
              <p className={`text-sm font-medium ${step.completed ? 'text-green-700' : 'text-gray-700'}`} data-id="element-128">
                {step.label}
              </p>
              {step.id === 'content' && <div className="mt-2 ml-1 space-y-2" data-id="element-129">
                  {course.modules.map(module => <div key={module.id} className="flex items-start" data-id="element-130">
                      {progress.completedModules.includes(module.id) ? <CheckSquare size={14} className="text-green-500 mt-0.5" data-id="element-131" /> : <Square size={14} className="text-gray-300 mt-0.5" data-id="element-132" />}
                      <p className="ml-2 text-xs text-gray-600" data-id="element-133">
                        {module.title}
                      </p>
                    </div>)}
                </div>}
            </div>
          </div>)}
      </div>
    </div>;
};
export default CourseProgress;